export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div>
            <div className="footer-logo-text">ASSU <span>BUILDTECH</span></div>
            <p className="footer-tagline">We Believe in Delivering<br /><strong>THE BEST</strong></p>
            <p className="footer-about-text">
              Your trusted partner for construction and real estate in Haryana &amp; Delhi NCR.
              Founded by Ashok Kumar. Building dreams, delivering excellence.
            </p>
            <div className="footer-socials-wrap">
              <a href="https://www.facebook.com/profile.php?id=61586915067932" className="footer-soc" target="_blank" rel="noreferrer" aria-label="Visit our Facebook page"><i className="fab fa-facebook-f" aria-hidden="true" /></a>
              <a href="https://www.instagram.com/assubuildtech/" className="footer-soc" target="_blank" rel="noreferrer" aria-label="Visit our Instagram profile"><i className="fab fa-instagram" aria-hidden="true" /></a>
              <a href="https://wa.me/918685838583" className="footer-soc" target="_blank" rel="noreferrer" aria-label="Chat with us on WhatsApp"><i className="fab fa-whatsapp" aria-hidden="true" /></a>
            </div>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Our Services</h4>
            <ul>
              {['Architecture & Design', 'Residential Construction', 'Industrial Construction', 'PEB Shed Projects', 'Interior Decoration', 'Project Management'].map(s => (
                <li key={s}><a href="#services" onClick={(e)=>{e.preventDefault();scrollTo('#services')}}>{s}</a></li>
              ))}
            </ul>
          </div>

          {/* Properties */}
          <div className="footer-col">
            <h4>Properties</h4>
            <ul>
              {['Residential Plots', 'Commercial Plots', 'Industrial Land', 'Villa Plots', 'Haryana Properties', 'Delhi NCR Properties'].map(p => (
                <li key={p}><a href="#properties" onClick={(e)=>{e.preventDefault();scrollTo('#properties')}}>{p}</a></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact Info</h4>
            <ul className="footer-contact-list">
              <li><i className="fas fa-user-tie" /> Ashok Kumar (Owner)</li>
              <li><i className="fas fa-phone-alt" /><a href="tel:+918685838583">86 8583 8583</a></li>
              <li><i className="fas fa-phone-alt" /><a href="tel:+918685838533">86 8583 8533</a></li>
              <li><i className="fas fa-envelope" /><a href="mailto:assubuildtech@gmail.com">assubuildtech@gmail.com</a></li>
              <li><i className="fas fa-map-marker-alt" /> Haryana &amp; Delhi NCR</li>
              <li><i className="fas fa-clock" /> Mon–Sat: 9AM–7PM</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>&copy; 2024 Assu Buildtech. All Rights Reserved. | Built for excellence</p>
          <p>Construction &amp; Real Estate | Haryana | Delhi NCR</p>
        </div>
      </div>
    </footer>
  )
}
